import React, { useState, useEffect } from 'react';
import { remoteConfig, getValue , fetchRemoteConfig } from '../../firebase';

const PrivacyPolicy = () => {
  const [content, setContent] = useState("Loading...");

  useEffect(() => {
     
    const loadRemoteConfig = async () => {
      try {
        // Make sure we actually fetch and activate latest values
        await fetchRemoteConfig();
        console.log("Remote Config all values:", remoteConfig._storageCache);
        const ppContent = getValue(remoteConfig, "privacyPolicy").asString();
        console.log("Fetched Privacy Policy:", ppContent);

        setContent(ppContent);
      } catch (error) {
        console.error("Error fetching T&C from Remote Config:", error);
        setContent("Failed to load terms and conditions. Please try again later.");
      }
    };

    loadRemoteConfig();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '50px auto' }}>
      <h1>Privacy Policy</h1>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default PrivacyPolicy;